/**
 * @generated SignedSource<<e47fa2766ea284481e5e2ce5f513254e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PaymentErrorType = "ERR_ETC" | "ERR_EXPIRE_URL";
export type TrpContentQuery$variables = {
  talkToken: string;
};
export type TrpContentQuery$data = {
  readonly paymentCardLink: {
    readonly errors: {
      readonly code: PaymentErrorType;
    } | null | undefined;
    readonly paymentUrl: string | null | undefined;
    readonly result: boolean;
  };
};
export type TrpContentQuery = {
  response: TrpContentQuery$data;
  variables: TrpContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "talkToken"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "talkToken",
        "variableName": "talkToken"
      }
    ],
    "concreteType": "PaymentCardLinkOutput",
    "kind": "LinkedField",
    "name": "paymentCardLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "paymentUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TrpContentQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TrpContentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2c5de3873de5b3a943c022784b1125e2",
    "id": null,
    "metadata": {},
    "name": "TrpContentQuery",
    "operationKind": "query",
    "text": "query TrpContentQuery(\n  $talkToken: String!\n) {\n  paymentCardLink(talkToken: $talkToken) {\n    result\n    paymentUrl\n    errors {\n      code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a5615eeed5f2fdd93cc79d7f7607b9e1";

export default node;
